/**
 * Shared utilities for chain information across system status components
 */

const CHAIN_NAMES: { [key: number]: string } = {
  11145513: "Blessnet Sepolia",
  45513: "Blessnet Mainnet",
  11155111: "Ethereum Sepolia",
  1: "Ethereum Mainnet",
  84532: "Base Sepolia",
  8453: "Base Mainnet",
  421614: "Arbitrum Sepolia",
  42161: "Arbitrum One",
  11155420: "OP Sepolia",
  10: "Optimism"
};

const CHAIN_LOGOS: { [key: number]: string } = {
  11145513: "/chain-logos/blessnet-logo.png", // Blessnet Sepolia
  45513: "/chain-logos/blessnet-logo.png",    // Blessnet Mainnet
  11155111: "/chain-logos/ethereum-logo.png", // Ethereum Sepolia
  1: "/chain-logos/ethereum-logo.png",        // Ethereum Mainnet
  84532: "/chain-logos/base-logo.png",        // Base Sepolia
  8453: "/chain-logos/base-logo.png",         // Base Mainnet
  421614: "/chain-logos/arbitrum-logo.png",   // Arbitrum Sepolia
  42161: "/chain-logos/arbitrum-logo.png",    // Arbitrum One
  11155420: "/chain-logos/optimism-logo.png", // OP Sepolia
  10: "/chain-logos/optimism-logo.png"        // Optimism
};

export const getChainName = (chainId: number | null): string => {
  if (chainId === null) return "Global";
  return CHAIN_NAMES[chainId] || `Chain ${chainId}`;
};

export const getChainLogo = (chainId: number | null): string => {
  if (chainId === null) return "/chain-logos/blessnet-logo.png";
  return CHAIN_LOGOS[chainId] || "/chain-logos/blessnet-logo.png";
};
